// Generated from aldelo-cloud.tokens.json v1.6.1 by scripts/gen-embed-tokens.mjs.
// Do not edit by hand: run `pnpm gen:embed-tokens`.

export const DS_VERSION = "1.6.1";

export const DS_COLOR_LIGHT = {
  "color.action": "#2f6aff",
  "color.action-hover": "#285ee8",
  "color.action-soft": "#edf2ff",
  "color.background": "#f7f8fb",
  "color.border": "#e1e5ec",
  "color.border-strong": "#cdd3dd",
  "color.control-border": "#7c879a",
  "color.danger": "#b42318",
  "color.danger-hover": "#9a1d14",
  "color.danger-soft": "#fff0f1",
  "color.data-2": "#7657d6",
  "color.focus": "#1d4ed8",
  "color.info": "#2b60e6",
  "color.info-soft": "#edf2ff",
  "color.link": "#2456e0",
  "color.link-hover": "#1d47bd",
  "color.on-action": "#ffffff",
  "color.on-danger": "#ffffff",
  "color.scrim": "rgba(17, 24, 39, .42)",
  "color.success": "#167348",
  "color.success-soft": "#edf7f1",
  "color.surface": "#ffffff",
  "color.surface-hover": "#f4f6fa",
  "color.surface-muted": "#f1f3f7",
  "color.text": "#151923",
  "color.text-disabled": "#98a1b0",
  "color.text-muted": "#5f6b7d",
  "color.text-strong": "#111827",
  "color.warning": "#8a5600",
  "color.warning-soft": "#fff5df",
  "component.field.background": "#ffffff",
  "component.panel.background": "#ffffff",
  "component.panel.border": "#e1e5ec",
  "shadow.overlay": "0 24px 64px rgba(18, 26, 40, .18), 0 2px 6px rgba(18, 26, 40, .06)",
  "shadow.panel": "0 1px 2px rgba(18, 26, 40, .045), 0 8px 24px rgba(18, 26, 40, .035)",
} as const;

export const DS_COLOR_DARK = {
  "color.action": "#7c8cff",
  "color.action-hover": "#92a0ff",
  "color.action-soft": "#24243b",
  "color.background": "#09090b",
  "color.border": "#34343a",
  "color.border-strong": "#45454d",
  "color.control-border": "#6a6a75",
  "color.danger": "#ff929f",
  "color.danger-hover": "#ffa8b2",
  "color.danger-soft": "#2b1f22",
  "color.data-2": "#b19cff",
  "color.focus": "#a5aeff",
  "color.info": "#8db8ff",
  "color.info-soft": "#1c2230",
  "color.link": "#a5b4ff",
  "color.link-hover": "#c0caff",
  "color.on-action": "#0b0b13",
  "color.on-danger": "#1a0b0e",
  "color.scrim": "rgba(0, 0, 0, .58)",
  "color.success": "#76e0a4",
  "color.success-soft": "#1d2420",
  "color.surface": "#121214",
  "color.surface-hover": "#1c1c21",
  "color.surface-muted": "#1a1a1f",
  "color.text": "#f4f4f5",
  "color.text-disabled": "#6b6b75",
  "color.text-muted": "#a7a7b0",
  "color.text-strong": "#f4f4f5",
  "color.warning": "#f5c96a",
  "color.warning-soft": "#29251c",
  "component.field.background": "#121214",
  "component.panel.background": "#121214",
  "component.panel.border": "#34343a",
  "shadow.overlay": "0 24px 64px rgba(0, 0, 0, .55), 0 0 0 1px rgba(255, 255, 255, .06)",
  "shadow.panel": "0 1px 0 rgba(255, 255, 255, .025)",
} as const;

export const DS_SCALAR = {
  "breakpoint.narrow": 560,
  "font.family.body": "\"SF Pro Text\", Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif",
  "font.family.mono": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", monospace",
  "font.line-height.body": 1.45,
  "font.line-height.heading": 1.3,
  "font.size.body": 13,
  "font.size.body-large": 14,
  "font.size.display": 30,
  "font.size.display-small": 22,
  "font.size.heading-small": 17,
  "font.size.input-touch": 16,
  "font.size.label": 12,
  "font.weight.medium": 500,
  "font.weight.regular": 400,
  "font.weight.strong": 700,
  "radius.control": 6,
  "radius.md": 8,
  "radius.sm": 4,
  "radius.xl": 12,
  "size.control": 38,
  "size.dialog-large": 760,
  "size.dialog-medium": 560,
  "size.dialog-small": 420,
  "size.form-max": 640,
  "size.touch-target": 44,
  "space.100": 4,
  "space.200": 8,
  "space.300": 12,
  "space.400": 16,
  "space.600": 24,
  "space.800": 32,
} as const;
